import { render, staticRenderFns } from "./DoKoTableStats.vue?vue&type=template&id=7302d81f&"
import script from "./DoKoTableStats.vue?vue&type=script&lang=ts&"
export * from "./DoKoTableStats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports